import { IValidation, json } from 'typia'

const MAX_LOGGED_ERRORS = 20
const MAX_VALUE_LENGTH = 100

export class ParsingError extends Error {
  constructor(errors: string, subject?: string) {
    const message = subject
      ? `Error parsing "${subject}" response data: ${errors}`
      : `Error parsing response data: ${errors}`
    super(message)
  }
}

const describeValue = (value: unknown): string => {
  let described: string
  try {
    described = JSON.stringify(value) ?? String(value)
  } catch {
    described = String(value)
  }
  return described.length > MAX_VALUE_LENGTH ? `${described.slice(0, MAX_VALUE_LENGTH)}…` : described
}

export const formatValidationErrors = (errors: IValidation.IError[]): string => {
  const lines = errors
    .slice(0, MAX_LOGGED_ERRORS)
    .map(error => `  ${error.path}: expected ${error.expected}, got ${describeValue(error.value)}`)
  if (errors.length > MAX_LOGGED_ERRORS) lines.push(`  …and ${errors.length - MAX_LOGGED_ERRORS} more`)
  return lines.join('\n')
}

export const logValidationFailure = (subject: string, errors: IValidation.IError[]) => {
  console.error(`Response validation failed for ${subject}:\n${formatValidationErrors(errors)}`, errors)
}

export function validateGuard<T>(validator: (input: unknown) => IValidation<T>, input: unknown, subject?: string): asserts input is T {
  const result = validator(input)
  if (!result.success) {
    logValidationFailure(subject ?? 'response data', result.errors)
    throw new ParsingError(json.stringify(result.errors), subject)
  }
}
